import { render } from "./EmploymentRequestFormModal.vue?vue&type=template&id=20c55f4a&scoped=true"
import script from "./EmploymentRequestFormModal.vue?vue&type=script&lang=js"
export * from "./EmploymentRequestFormModal.vue?vue&type=script&lang=js"

import "./EmploymentRequestFormModal.vue?vue&type=style&index=0&id=20c55f4a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20c55f4a"

export default script